export default {
    TRANSITIONED: 'transitioned',
    NOT_TRANSITIONED: 'not transitioned'
}